module.exports = __webpack_public_path__ + "static/media/YF39_3.b9405f6f.jpg";